<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button (click)="closePopUpOfQuote()" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <mat-tab-group class="tabs-group edit-order-grp" [(selectedIndex)]="selectedIndex">
      <mat-tab label="Order">
        <div [formGroup]="form1" class="forms w-100 d-block">
          <div class="d-flex">
            <div class="col-lg-12">
              <div class="d-flex">
                <div class="col-lg-6">
                  <span class="p-float-label w-100 mb-3">
                    <p-calendar #checkInDateCal autofocus class="error-bg" placeholder="Select Date" formControlName="checkInDateTime" appendTo="body"
                      selectOtherMonths="true" inputId="checkInDateTime" [showTime]="false" dateMask (mouseup)="onKeyDate($event)"
                      (onSelect)="checkInChange($event)" [minDate]="minDate" [maxDate]="maxDate" [readonlyInput]="false">
                      <ng-template pTemplate="date" let-date>
                        <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
                      </ng-template>
                    </p-calendar>
                    <label for="checkInDateTime">CheckIn Date</label>
                    @for (validation of validationMessages.checkInDateTime; track validation) {
                      <span>
                        @if (form1.get('checkInDateTime').hasError(validation.type) && (form1.get('checkInDateTime').dirty || form1.get('checkInDateTime').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="col-lg-6">
                  <span class="p-float-label w-100 mb-3">
                    <p-calendar #checkOutDateCal class="error-bg" placeholder="Select Date" formControlName="checkOutDateTime" appendTo="body"
                      selectOtherMonths="true" inputId="checkOutDateTime" [showTime]="false" (onClose)="openGuestModal($event)" dateMask
                      (keyup)="compareDate($event)" (mouseup)="onKeyDateForCheckOutDate($event)" (onSelect)="checkOutChange($event)"
                      selectOtherMonths="true" [defaultDate]="checkOutDateBasedOnCheckinDate"
                      [minDate]="updatedCheckInDate" [maxDate]="maxDate" [readonlyInput]="false">
                      <ng-template pTemplate="date" let-date>
                        <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
                      </ng-template>
                    </p-calendar>
                    <label for="checkOutDateTime">CheckOut Date</label>
                    @for (validation of validationMessages.checkOutDateTime; track validation) {
                      <span>
                        @if (form1.get('checkOutDateTime').hasError(validation.type) && (form1.get('checkOutDateTime').dirty || form1.get('checkOutDateTime').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>
              <div class="d-flex">
                <div class="col-lg-6  mb-3">
                  <span class="p-float-label w-100">
                    <p-dropdown [options]="numAdults" formControlName="numAdults" optionLabel="name" optionValue="value"
                    placeholder="Adults"></p-dropdown>
                    <label for="numAdults">Adults</label>
                    @for (validation of validationMessages.numAdults; track validation) {
                      <span>
                        @if (form1.get('numAdults').hasError(validation.type) && (form1.get('numAdults').dirty || form1.get('numAdults').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="col-lg-6  mb-3">
                  <span class="p-float-label w-100">
                    <p-dropdown [options]="childrens" formControlName="numChildren" optionLabel="name" optionValue="value"
                    placeholder="Children"></p-dropdown>
                    <label for="numChildren">Children</label>
                    @for (validation of validationMessages.numChildren; track validation) {
                      <span>
                        @if (form1.get('numChildren').hasError(validation.type) && (form1.get('numChildren').dirty || form1.get('numChildren').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>
              <div class="col-lg-6">
                <span class="p-float-label w-100 mb-3">
                  <p-calendar #expireDateCal class="error-bg" placeholder="Select Date" formControlName="quoteExpirationDateTime" appendTo="body"
                    selectOtherMonths="true" inputId="quoteExpirationDateTime" [showTime]="false" dateMask
                    [showTime]="true" (keyup)="compareDate($event)" (onSelect)="checkOutChange($event)"
                    selectOtherMonths="true"
                    [minDate]="minDate" [maxDate]="maxDate" [readonlyInput]="false">
                    <ng-template pTemplate="date" let-date>
                      <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
                    </ng-template>
                  </p-calendar>
                  <label for="quoteExpirationDateTime">Expire Date</label>
                  @for (validation of validationMessages.quoteExpirationDateTime; track validation) {
                    <span>
                      @if (form1.get('quoteExpirationDateTime').hasError(validation.type) && (form1.get('quoteExpirationDateTime').dirty || form1.get('quoteExpirationDateTime').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3">
                  <span class="p-float-label w-100 d-flex">
                    <p-checkbox [formControl]="form1.controls['sendEmail']" inputId="sendEmail" [binary]="true"></p-checkbox>
                    <span class="test-nm">Email</span>
                  </span>
                  @for (validation of validationMessages.sendEmail; track validation) {
                    <span>
                      @if (form1.get('sendEmail').hasError(validation.type) && (form1.get('sendEmail').dirty || form1.get('sendEmail').touched)) {
                        <small class="p-invalid"
                          >
                          {{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
        </div>
      </div>
    </div>
</mat-tab>
<mat-tab label="Guest Communication">
  <span>Guest Communication</span>
</mat-tab>
</mat-tab-group>

<hr>

  @if (selectedIndex==0) {
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (form1.value.quoteId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Quote</button>
            }
          </div>
          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!form1.value.quoteId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Quote</button>
            }
            @if (form1.value.quoteId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Quote</button>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
